import Link from 'next/link'
import { useEffect, useState } from 'react'
import { Star } from 'lucide-react'

import { getRecommendedBills } from '@/app/actions/recommended-bills'
import { Button } from '@/components/ui/button'
import { Bill, Topic } from '@/payload-types'

import { BillsListing } from './BillsListing'
import { BillsLoading } from './BillsLoading'

const NoBills: React.FC = () => {
  return (
    <div className="mx-auto flex max-w-sm items-center justify-center gap-2 rounded-2xl py-8 font-body lg:pt-2 lg:pb-8 xl:pt-6 xl:pb-16">
      <div className="flex flex-col items-center justify-center gap-4 text-center text-balance">
        <div className="flex size-14 items-center justify-center rounded-xl bg-evergreen-100 p-2">
          <Star className="size-8 text-evergreen-800" />
        </div>
        <h3 className="text-2xl font-semibold text-foreground">
          We have no recommendations for you. Please check again later.
        </h3>
        <div className="flex items-center justify-center gap-2">
          <Button variant="accent" className="flex w-fit items-center" asChild>
            <Link href={`/legislative-tracker`}>Browse bills</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export const RecommendedBills = ({ allBillTopics }: { allBillTopics: Topic[] }) => {
  const [recommendedBills, setRecommendedBills] = useState<Bill[]>([])
  const [loadingBills, setLoadingBills] = useState<boolean>(true)

  useEffect(() => {
    let cancelled = false
    async function fetchData() {
      const data = await getRecommendedBills()
      if (!cancelled) {
        setRecommendedBills(data)
        setLoadingBills(false)
      }
    }
    void fetchData()
    return () => {
      cancelled = true
      setLoadingBills(true)
    }
  }, [])

  if (loadingBills) return <BillsLoading />

  return recommendedBills.length > 0 ? (
    <BillsListing bills={recommendedBills} allBillTopics={allBillTopics} />
  ) : (
    <NoBills />
  )
}
